import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(() => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  searchBar: {
    width: '300px',
  },
  tableContainer: {
    flex: 1,
    margin: '20px 2% 20px 34px',
  },
  mainTable: {
    width: 'auto',
    height: '616px',
  },
}))

export const datagridStyle = {
  fontSize: Theme.Typography.FontSize.XXSmall,

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
